/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

//服务订单列表
exports.getServOrderList = function (postData, callback) {// 服务订单列表
    api.post('/servc/order/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getServOrderInfo = function (postData, callback) {// 获取服务订单明细
    api.post('/servc/order/info/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.saveServcOrderForContract = function (postData, callback) {// 保存合同订单信息
    api.post('/servc/order/save/do/for/contract')
    .data(postData)
    .done(callback)
    .go();
};
exports.saveServcOrderAfterSale = function (data, callback) {// 保存售后服务订单信息
    api.post('/servc/order/after/sale/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcOrderInfoByIdAndItemId = function (data, callback) {// 通过订单id，与订单项id获取订单和订单项的信息（售后下单用）
    api.post('/servc/order/info/get/by/id/and/itemId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServOrderRecordList = function (data, callback) {// 服务订单记录
    api.post('/servc/order/record/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doCancelGoodsOrder = function (data, callback) {// 服务订单记录
    api.post('/servc/order/cancel/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcOrder.js
// module id = 148
// module chunks = 0